import * as tslib_1 from "tslib";
import { EffectEnvMapChunk } from "./EffectEnvMapChunk";
/**
 * EffectFresnelEnvMapChunk provides a method to add fresnel-based reflectivity to an object using cube maps, which gets
 * stronger as the viewing angle becomes more grazing.
 */
var EffectFresnelEnvMapChunk = (function (_super) {
    tslib_1.__extends(EffectFresnelEnvMapChunk, _super);
    function EffectFresnelEnvMapChunk() {
        return _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    EffectFresnelEnvMapChunk.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var dataRegister = registerCache.getFreeFragmentConstant();
        var code = "";
        var viewDirReg = sharedRegisters.viewDirFragment;
        var normalReg = sharedRegisters.normalFragment;
        this._fragmentIndex = dataRegister.index * 4;
        var temp = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(temp, 1);
        var temp2 = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(temp2, 1);
        // r = V - 2(V.N)*N
        code += "dp3 " + temp + ".w, " + viewDirReg + ".xyz, " + normalReg + ".xyz\n" +
            "add " + temp + ".w, " + temp + ".w, " + temp + ".w\n" +
            "mul " + temp + ".xyz, " + normalReg + ".xyz, " + temp + ".w\n" +
            "sub " + temp + ".xyz, " + temp + ".xyz, " + viewDirReg + ".xyz\n" +
            this._envMap._getFragmentCode(temp, registerCache, sharedRegisters, temp) +
            "sub " + temp2 + ".w, " + temp + ".w, fc0.x\n" +
            "kil " + temp2 + ".w\n" +
            "sub " + temp + ", " + temp + ", " + targetReg + "\n";
        // calculate fresnel term
        code += "dp3 " + viewDirReg + ".w, " + viewDirReg + ".xyz, " + normalReg + ".xyz\n" +
            "sub " + viewDirReg + ".w, " + dataRegister + ".w, " + viewDirReg + ".w\n" +
            "pow " + viewDirReg + ".w, " + viewDirReg + ".w, " + dataRegister + ".z\n" +
            "sub " + normalReg + ".w, " + dataRegister + ".w, " + viewDirReg + ".w\n" +
            "mul " + normalReg + ".w, " + dataRegister + ".y, " + normalReg + ".w\n" +
            "add " + viewDirReg + ".w, " + viewDirReg + ".w, " + normalReg + ".w\n" +
            // total alpha
            "mul " + viewDirReg + ".w, " + dataRegister + ".x, " + viewDirReg + ".w\n";
        if (this._maskMap) {
            code += this._maskMap._getFragmentCode(temp2, registerCache, sharedRegisters, sharedRegisters.uvVarying) +
                "mul " + viewDirReg + ".w, " + temp2 + ".x, " + viewDirReg + ".w\n";
        }
        // blend
        code += "mul " + temp + ", " + temp + ", " + viewDirReg + ".w\n" +
            "add " + targetReg + ", " + targetReg + ", " + temp + "\n";
        registerCache.removeFragmentTempUsage(temp);
        registerCache.removeFragmentTempUsage(temp2);
        return code;
    };
    EffectFresnelEnvMapChunk.prototype._updateProperties = function () {
        var index = this._fragmentIndex;
        var data = this._shader.fragmentConstantData;
        data[index] = this._method.alpha;
        data[index + 1] = this._method.normalReflectance;
        data[index + 2] = this._method.fresnelPower;
    };
    return EffectFresnelEnvMapChunk;
}(EffectEnvMapChunk));
export { EffectFresnelEnvMapChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/EffectFresnelEnvMapChunk.js